
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqAQKgu_bOnmNsyxxWmyPqCNQbz3ns6F0myZgZBvmeRUAMeta } from "/codebuild/output/src745966679/src/src/pages/faq.vue?macro=true";
import { default as menugU1ZB3wFKEllJe3leeqXEvhss845OP56PpudBC2GoTQMeta } from "/codebuild/output/src745966679/src/src/pages/menu.vue?macro=true";
import { default as indexWTTLwPK3XYmBpzGBQWuvtd6pfqFuVRiTS8z1W2MNyvUMeta } from "/codebuild/output/src745966679/src/src/pages/index.vue?macro=true";
import { default as contactjFIDWPY0hxa5rcL9Hav4HfTovGoGWL_7eDF_Yhjo69QMeta } from "/codebuild/output/src745966679/src/src/pages/contact.vue?macro=true";
import { default as tutorialXkt_E1agJuz2uX34lJ8e4kGLIeQI_cQlRioYBkkeZvoMeta } from "/codebuild/output/src745966679/src/src/pages/tutorial.vue?macro=true";
import { default as agreementGSGRfD1Fa1eCbbE65N2x5Ku2JByY5SnXIBX6dWA_lJYMeta } from "/codebuild/output/src745966679/src/src/pages/agreement.vue?macro=true";
import { default as about_45passgVZjW14ptG2W40f7RR_npYIw_xGbB8emAB5RQEXF3gEMeta } from "/codebuild/output/src745966679/src/src/pages/about-pass.vue?macro=true";
import { default as index9THylM5yW6Vs0lFldU3GlQQ9dAjGt8AL58aoZ3359vEMeta } from "/codebuild/output/src745966679/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93FsJ0WRdluNI0XwNu12UTBokE_45eohyYTSCs57iWyt29sMeta } from "/codebuild/output/src745966679/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceeSEyFdHWSVQxzhgNvrLQcYcXfytnhHWmMKSLR6km6hsMeta } from "/codebuild/output/src745966679/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93iJt9CId8QuOJkLoKwFfdrgf9r_sGPBB68RyTtcQA6DQMeta } from "/codebuild/output/src745966679/src/src/pages/notice/[id].vue?macro=true";
import { default as indexAGJTErcviQ4UWcYBOu26bYUrdBYoddjLN5RuOldJZGQMeta } from "/codebuild/output/src745966679/src/src/pages/coupon/index.vue?macro=true";
import { default as indexLwB8W3P6T8NG4V1_TGNf9cRN8ZNKaauNG992VWJ0GtkMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/index.vue?macro=true";
import { default as indexpkTCnnVdXvz6pIM7K4nr_QB8KPJkHIicooc5vJ6npW8Meta } from "/codebuild/output/src745966679/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93S8wyycvcQq7p7gCzGc_xK8Ry9rCaA6JxmdT79cQVJykMeta } from "/codebuild/output/src745966679/src/src/pages/parking/[id].vue?macro=true";
import { default as indexFhA_45V4llmd_45Ll5vVuXFvHEGKWctPHUx_45ld943bZLqXQMeta } from "/codebuild/output/src745966679/src/src/pages/history/index.vue?macro=true";
import { default as indexTqYKY3_45oJgJbMgL09LJi8utIcNn8HvgRGoFdRove_AwMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/index.vue?macro=true";
import { default as indexgAiiprIkCPzS1yScaKcESZo_UDlIJNUDvdK3sBHONZQMeta } from "/codebuild/output/src745966679/src/src/pages/sign-in/index.vue?macro=true";
import { default as index1vIYZ_Y4XrAc7xhJfkv0CcUsxzdnHkx_45vvO2ZK4SsbcMeta } from "/codebuild/output/src745966679/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi5mB5eUlivZrh7wImi327vFA15J4_AIvuiTaNjZVaHcMMeta } from "/codebuild/output/src745966679/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit69BMdoFjJukS381wUsCRvDaq6j97cf2HAggtNZJ9XBUMeta } from "/codebuild/output/src745966679/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementtFGDxfl1By1IirKEqviXF3W6sjxnJcrSLMvPjX5TXlkMeta } from "/codebuild/output/src745966679/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexOKJpjR4e8PzUevGJy9vwbcZKrPAbVgqnhg2kFyVoptwMeta } from "/codebuild/output/src745966679/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dbTEj654Gsvnnyzh3DgTb8Gb9CJxj_d9uTRT4f8a4vMQMeta } from "/codebuild/output/src745966679/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmz8LUQnmvWcDYi0pAgVU4M4D_KYu3D3iccWkFCd_45jcrUMeta } from "/codebuild/output/src745966679/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexa_45cQNIX_454N_ruQJdrGLoY_9fQPZwTDO1ze9DMiuQXG8Meta } from "/codebuild/output/src745966679/src/src/pages/card/create/index.vue?macro=true";
import { default as indexK_45HrR8K1o5IudDgHWAVBZ6H5b8zSJ_HKH5aItC_7cDAMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmJdOgULZc3DAHDMRbIBhBPuEBOaqn77PY3BMy_OnL2U4Meta } from "/codebuild/output/src745966679/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmqTq2I5R2C_5BklGK27Qdi18zSpis2Sdo4GlJ5TgncI0Meta } from "/codebuild/output/src745966679/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeyfiA_45OgdKPja2oUF1evnAx4yT8mYQ4KeieMreAsjVOoMeta } from "/codebuild/output/src745966679/src/src/pages/membership/complete.vue?macro=true";
import { default as registerTkH5eh_zaAkRF4cNq5Lac2_45euW3B9m64LuoCT5JhGrgMeta } from "/codebuild/output/src745966679/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93ROwXuPGt_lXHtOaCBnd7sy_45BuoVC9_45o504nfNVpM3McMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmUI25fVz5QISmbc_4531QgOmRvEgWlJiWlFTjTpjzWczdIMeta } from "/codebuild/output/src745966679/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93NSsMLD1OE7wpguR8rYYyHZNzPgi8PmMtWZwzQ5NhwKcMeta } from "/codebuild/output/src745966679/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexJGhWcA2G_c697GuqzpJCZH2bo_45lb17zzV8YfTK_PO5IMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeODglnxh8hvu0vEGQbmWRerkcpTdvy5bZ7M5FnUMynkkMeta } from "/codebuild/output/src745966679/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeQY35wXaoERVH_45eDunSJ5bnynQI17_45tqxMV7XZi62XlwMeta } from "/codebuild/output/src745966679/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete1B1ZfF69NxMHQCxDeR0_45C9uSBMLQcNgYgEGsem4TQogMeta } from "/codebuild/output/src745966679/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerj8N_NPucVVeVK2pjoKMwBouel4qzGpgviCsQ3AIz0uwMeta } from "/codebuild/output/src745966679/src/src/pages/contact-form/register.vue?macro=true";
import { default as completewJRLynQX7SCXi9Oy1UPlogTbZgSI2kUxLtdBfkdP4F0Meta } from "/codebuild/output/src745966679/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexS4yH35tP56i5W0E8Wh867P3mVCf5You8DOuPQkomgLkMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmy1lz7sIumdFGxW8EdrwIM092ZvvyS52J4kIkM62KTZoMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completecbUAE2LRLhMl9Am_EyXqqkS7n1c6JQc7Jn95lgAONsEMeta } from "/codebuild/output/src745966679/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexWt0_45E1RitAW9YBzQUXhqWx8159AA152IARkF0VoE7ksMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_938y94sO3vuPR1zK3GcGeOzE0CdMDn8y4A_451ufBsgSKMYMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completepLppkdqMDOdjxTkrvNwaDz1xazv_8ViJ_T3CjzWPpuMMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliassLCybBfrukrorv6d9MwYS01bmmiV_JFsZ7ZQKi0g4qQMeta } from "/codebuild/output/src745966679/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampledqCX73Q_45wM6hM9paYS2HggxPBtDhdCEuNg8G_7ztsgMMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailYwncoaD2gLtPigHq8t2i4ypA04ol0P_45HvAgUT_SfmPIMeta } from "/codebuild/output/src745966679/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmEoMpx_Kwb2przjRkHSLJbx62U8Fad1iBgTa4Cbv_jAMMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentunEJanevh5vZd5EGnLAIqnxKhucJSW1SHwWLcMNJlKIMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmymzNnZK_f8tqZQxnB1yV2FIRG_WxtSJznOt13R0wFmEMeta } from "/codebuild/output/src745966679/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate7fW52n7N9HJIdoC_g1PHfcOP7JLRN0biftAUq0iKjWkMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeNODCVDSz_453EILaPQWR39HWrxnUYmWCHKvR4DXu50oBcMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codemYjEV4ep50yMeqy2jggzUN1wJG6EzsXRqhOjCnOOVWkMeta } from "/codebuild/output/src745966679/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password3JWqhkcStXdThqQBGjYqbWrcxyFZGDEMGq0oc7SS00wMeta } from "/codebuild/output/src745966679/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliastHXLg43lJtsg76WlIy7k6xEHjtYREAN7FRrOi_c6OP0Meta } from "/codebuild/output/src745966679/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registeri2anlMI222PDOlPr5OZ5BldhjMfjRdsaWSeM6YOSB5AMeta } from "/codebuild/output/src745966679/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codev6x41xr1a_45Cuv4BIhv7rtChoMSZjKoGeaqBrx0_45cJDQMeta } from "/codebuild/output/src745966679/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexyyBlI7aXaNoVudgh1uLOhnwpyTZUpJInkWHMIfsavg8Meta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexKY9x6papHM0wMajrX_e5rayaq20m8mS8vCx_45dni8pzsMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index2eadkEkX1G_kiSDrTqQ_lgR51tJc3PCtrHUIr52mfVYMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexpPX2MUiNLvEppMinQ8TZK_45Aqb_45thvpPesTAy7v_Oy18Meta } from "/codebuild/output/src745966679/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateZg634bQ_gIOBJq_45exM30b3YzdxqoTnDVDFN1MlyZQ6gMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete_BCCjHukN4y0d69u0cDlnfJXNFRW6DN3j3O8AgM1GmgMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmp_45tnAlJvZltDdD6Qz6XyPggpkOKyk7qE_WDYOF5S42EMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexx4_3thF0rStQJRh_45FBvCuQpDenJaenDlZFeJWtC__XwMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completehkc3Gtfmr74H109J26QYkj9jVt9WSukdZY9aF1N0gaYMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateJXSh35DqQBJ_45zH7ogVjIPtOXP4YnNsXFCnzPy3ACAOYMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexce_lz9TIH5rJyGnVOppwJRF3QR_uYVkWphTdq7Cl51YMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexc5ZtZvCNz2C23PMkf0Yy1tfSW5FQh4pTKzcczexVercMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeCcQpT_450QxcwTaYZkCKeXaA7AhVqmZACDlVyxwdN2QswMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexUVbJ_2R_458u4XJII_45btAwFHWX3Rr_d11ndrEahei6zswMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeA5mhnw6ltFpqIi0mo8LyKJjfvpMRIN_45B4CoaPNOu63IMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexP47KPh0VzdM_45ga31QXbSONo5Za1torJ3BBgMgFZ04XYMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexZUu4vUr2N9msPaSr7_3x_45PHCbKUHsUlD_0ncTBMX8YwMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexUNgl8AnS7fOjFqPuiwXIAUIWpoUUZU9vftSEt8DXVPoMeta } from "/codebuild/output/src745966679/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update3v9Wrr_ad8SAePpDaEzYCrIH3uJyL9dNJcBPcRiS7_sMeta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmWQWukDKmxcxPa1j_Ts_450z_452s0nCHIXBmxu_456Dx93GD8Meta } from "/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src745966679/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menugU1ZB3wFKEllJe3leeqXEvhss845OP56PpudBC2GoTQMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexWTTLwPK3XYmBpzGBQWuvtd6pfqFuVRiTS8z1W2MNyvUMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src745966679/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src745966679/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src745966679/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src745966679/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src745966679/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src745966679/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexAGJTErcviQ4UWcYBOu26bYUrdBYoddjLN5RuOldJZGQMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src745966679/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src745966679/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src745966679/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexFhA_45V4llmd_45Ll5vVuXFvHEGKWctPHUx_45ld943bZLqXQMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src745966679/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexgAiiprIkCPzS1yScaKcESZo_UDlIJNUDvdK3sBHONZQMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index1vIYZ_Y4XrAc7xhJfkv0CcUsxzdnHkx_45vvO2ZK4SsbcMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src745966679/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src745966679/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src745966679/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src745966679/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src745966679/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexa_45cQNIX_454N_ruQJdrGLoY_9fQPZwTDO1ze9DMiuQXG8Meta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmJdOgULZc3DAHDMRbIBhBPuEBOaqn77PY3BMy_OnL2U4Meta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmqTq2I5R2C_5BklGK27Qdi18zSpis2Sdo4GlJ5TgncI0Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src745966679/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeyfiA_45OgdKPja2oUF1evnAx4yT8mYQ4KeieMreAsjVOoMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerTkH5eh_zaAkRF4cNq5Lac2_45euW3B9m64LuoCT5JhGrgMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmUI25fVz5QISmbc_4531QgOmRvEgWlJiWlFTjTpjzWczdIMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeODglnxh8hvu0vEGQbmWRerkcpTdvy5bZ7M5FnUMynkkMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeQY35wXaoERVH_45eDunSJ5bnynQI17_45tqxMV7XZi62XlwMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete1B1ZfF69NxMHQCxDeR0_45C9uSBMLQcNgYgEGsem4TQogMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerj8N_NPucVVeVK2pjoKMwBouel4qzGpgviCsQ3AIz0uwMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmy1lz7sIumdFGxW8EdrwIM092ZvvyS52J4kIkM62KTZoMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completecbUAE2LRLhMl9Am_EyXqqkS7n1c6JQc7Jn95lgAONsEMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexWt0_45E1RitAW9YBzQUXhqWx8159AA152IARkF0VoE7ksMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completepLppkdqMDOdjxTkrvNwaDz1xazv_8ViJ_T3CjzWPpuMMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src745966679/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampledqCX73Q_45wM6hM9paYS2HggxPBtDhdCEuNg8G_7ztsgMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailYwncoaD2gLtPigHq8t2i4ypA04ol0P_45HvAgUT_SfmPIMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmEoMpx_Kwb2przjRkHSLJbx62U8Fad1iBgTa4Cbv_jAMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentunEJanevh5vZd5EGnLAIqnxKhucJSW1SHwWLcMNJlKIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmymzNnZK_f8tqZQxnB1yV2FIRG_WxtSJznOt13R0wFmEMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeNODCVDSz_453EILaPQWR39HWrxnUYmWCHKvR4DXu50oBcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codemYjEV4ep50yMeqy2jggzUN1wJG6EzsXRqhOjCnOOVWkMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password3JWqhkcStXdThqQBGjYqbWrcxyFZGDEMGq0oc7SS00wMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src745966679/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registeri2anlMI222PDOlPr5OZ5BldhjMfjRdsaWSeM6YOSB5AMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codev6x41xr1a_45Cuv4BIhv7rtChoMSZjKoGeaqBrx0_45cJDQMeta || {},
    component: () => import("/codebuild/output/src745966679/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src745966679/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src745966679/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]